import type { ITableHeaderConfig } from '../../../../utils/types';

export const goalsProgressHeaderConfig: Array<ITableHeaderConfig> = [
  {
    label: 'Parent/caregiver goals',
    sx: { flexGrow: 1 },
    labelAlign: 'left',
  },
  {
    label: 'Needs improvement \n Success: 0-50%',
    sx: { width: 200, display: 'flex', alignItems: 'center' },
  },
  {
    label: 'Meets expectations \n Success: 50-80%',
    sx: { width: 200, display: 'flex', alignItems: 'center' },
  },
  {
    label: 'Exceeds expectations \n Success: 80-100%',
    sx: { width: 200, display: 'flex', alignItems: 'center' },
  },
];

export const PARENT_PROGRESS_OPTIONS = [
  { value: 'POSITIVE', label: 'Positive' },
  { value: 'NEUTRAL', label: 'Neutral' },
  { value: 'NEGATIVE', label: 'Negative' },
];

export enum GOAL_EVALUATION_ENUM {
  NEEDS_IMPROVEMENT = 'NEEDS_IMPROVEMENT',
  MEETS_EXPECTATIONS = 'MEETS_EXPECTATIONS',
  EXCEEDS_EXPECTATIONS = 'EXCEEDS_EXPECTATIONS',
}

export const boxContainerStyle = {
  borderRadius: '20px',
  mt: 3,
  flexGrow: 0,
  boxShadow: 'none',
};

export const boxContainerHeaderStyle = {
  height: 40,
  flexGrow: 0,
  boxShadow: 'none',
  borderRadius: '16px 16px 0 0',

  '& h4': {
    fontSize: 20,
    fontWeight: 500,
  },
};

export const contentStyle = {
  p: '20px',
  height: 'auto',
};
